export default class Countdown {
  constructor(el) {
    this.el = el;
    this.value = document.getElementById("countdown").getAttribute("value");
    this.date = new Date(this.value).getTime();
    this.countdown = document.getElementById("tiles");
    this.init();
    this.initEvents();
  }
  pad(n) {
    return (n < 10 ? "0" : "") + n;
  }
  getCountdown() {
    let current_date = new Date().getTime();
    let days, hours, minutes, seconds;
    var seconds_left = (this.date - current_date) / 1000;

    days = this.pad(parseInt(seconds_left / 86400));
    seconds_left = seconds_left % 86400;

    hours = this.pad(parseInt(seconds_left / 3600));
    seconds_left = seconds_left % 3600;

    minutes = this.pad(parseInt(seconds_left / 60));
    seconds = this.pad(parseInt(seconds_left % 60));

    if (this.date > current_date) {
      this.countdown.innerHTML =
        "<span>" +
        days +
        "</span><span>" +
        hours +
        "</span><span>" +
        minutes +
        "</span><span>" +
        seconds +
        "</span>";
    } else {
      this.countdown.innerHTML =
        "<span>00</span><span>00</span><span>00</span><span>00</span>";
    }
  }
  init() {
    if (this.date) {
      this.getCountdown();
      setInterval(() => {
        this.getCountdown();
      }, 1000);
    }
    //this.getCountdown();
  }

  initEvents() {}
}
